'use client'

import { GoogleTagManager } from '@next/third-parties/google'
import { useEffect, useState } from 'react'

type DeferredGoogleTagManagerProps = {
  gtmId?: string
}

// @next/third-parties' GoogleTagManager always loads its scripts with next/script's
// default 'afterInteractive' strategy - there's no prop to push it later. Delaying when
// the component itself mounts is the only way to keep it off the hydration-critical path.
export function DeferredGoogleTagManager({ gtmId }: DeferredGoogleTagManagerProps) {
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    if ('requestIdleCallback' in window) {
      // Without a timeout, a sustained-busy main thread could delay this indefinitely
      // and a visitor who bounces before it fires never gets counted.
      const id = window.requestIdleCallback(() => setShouldLoad(true), { timeout: 2000 })
      return () => window.cancelIdleCallback(id)
    }

    const id = setTimeout(() => setShouldLoad(true), 1)
    return () => clearTimeout(id)
  }, [])

  if (!shouldLoad || !gtmId) return null

  return <GoogleTagManager gtmId={gtmId} />
}
